import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="py-20 px-4 bg-white" data-id="element-270" data-mp="3fznuxono1h2y">
      <div className="max-w-6xl mx-auto" data-id="element-271" data-mp="3fycrjpy4ubcd">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-stone-800 text-center uppercase tracking-wide mb-12" data-id="element-272" data-mp="3fxb4so7r80et">
          What Makeup Educators Are Saying
        </h2>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-273" data-mp="370akasnt2mgn">
          {testimonials.map((t, i) => <motion.figure key={t.role} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: i * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-rose-50 border border-rose-100 p-8 rounded-2xl flex flex-col h-full" data-id="element-274" data-mp="31yl4kzpn1km8" data-mpi={i}>
              <Quote size={28} className="text-rose-300 mb-5" aria-hidden="true" data-id="element-275" data-mp="m5syeewqrwn3" />
              <blockquote className="text-stone-700 leading-relaxed flex-grow mb-8" data-id="element-276" data-mp="7a4yh1yghvp0">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-auto pt-5 border-t border-rose-200 text-sm font-semibold uppercase tracking-wider text-rose-800" data-id="element-277" data-mp="zw65yg5q19bw">
                {t.role}
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}